module.exports = __webpack_public_path__ + "img/Reasonably-Pack.e9efcf7e.jpg";